import LanguageSelector from "components/template/LanguageSelector";
import useWindowSize from "components/ui/hooks/useWindowSize";
import { REDIRECT_URL_KEY } from "constants/app.constant";
import React, { useState } from "react";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useQuery from "utils/hooks/useQuery";

const Welcome = () => {
  const navigate = useNavigate();
  const locale = useSelector((state) => state.theme.locale);
  const query = useQuery();
  const { width } = useWindowSize();
  const images = [
    `/img/others/welcome-1-${locale}-${width < 768 ? "mobil" : "web"}.png`,
    `/img/others/welcome-2-${locale}-${width < 768 ? "mobil" : "web"}.png`,
    `/img/others/welcome-3-${locale}-${width < 768 ? "mobil" : "web"}.png`,
  ];
  const [selectedImage, setSelectedImage] = useState(0);
  const handleArrowClick = (type) => {
    if (type === "next") {
      if (selectedImage < images.length - 1) {
        setSelectedImage(selectedImage + 1);
      } else {
        setSelectedImage(0);
      }
    } else {
      if (selectedImage > 0) {
        setSelectedImage(selectedImage - 1);
      } else {
        setSelectedImage(images.length - 1);
      }
    }
  };

  const handleStart = () => {
    localStorage.setItem("welcome", true);
    const redirectUrl = query.get(REDIRECT_URL_KEY);
    if (redirectUrl) {
      navigate(`/sign-in?${REDIRECT_URL_KEY}=${redirectUrl}`);
    } else {
      navigate("/sign-in");
    }
  };

  return (
    <div className="flex-1 flex items-start mt-10 md:items-center md:mt-0 justify-center px-5">
      <div>
        <div className="flex justify-end">
          <LanguageSelector withText />
        </div>
        <div className="max-w-7xl mx-auto p-1 bg-white rounded-md shadow-lg m-5 relative">
          <img
            alt="welcome"
            src={images[selectedImage]}
            className="select-none"
          />
          {selectedImage === 2 ? (
            <div
              className="absolute top-1/2 -right-0  p-2 bg-slate-50 text-kostebek-500 cursor-pointer hover:bg-kostebek-500 hover:text-white"
              onClick={() => handleStart()}
            >
              <p className="text-lg font-semibold">
                {locale === "tr" ? "Başla" : "Start"}
              </p>
            </div>
          ) : (
            <div
              className="absolute top-1/2 -right-0  p-2 bg-slate-50 text-kostebek-500 cursor-pointer hover:bg-kostebek-500 hover:text-white"
              onClick={() => handleArrowClick("next")}
            >
              <HiChevronRight className="text-xl md:text-3xl " />
            </div>
          )}
          {selectedImage === 0 ? (
            <span></span>
          ) : (
            <div
              className="absolute top-1/2 -left-0  p-2 bg-slate-50 text-kostebek-500 cursor-pointer hover:bg-kostebek-500 hover:text-white"
              onClick={() => handleArrowClick("prev")}
            >
              <HiChevronLeft className="text-xl md:text-3xl " />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Welcome;
